module.exports = __webpack_public_path__ + "static/media/heroimage_igib-020.22f04d43.jpg";